/**
 * 全局常量定义。
 */

// 色彩常量（与 Tailwind 配置一致）
export const COLORS = {
  warmWhite: '#FAF7F2',
  warmBrown: '#7C6F5C',
  lightBrown: '#A99F8E',
  safeGreen: '#6B8E7B',
  emotionOrange: '#C49A6C',
  rationalBlue: '#5A7D9A',
  instinctRed: '#B86B6B',
} as const;

// 布局尺寸（像素）
export const LAYOUT = {
  SIDEBAR_WIDTH: 240,
  INSIGHT_WIDTH: 320,
  TOPBAR_HEIGHT: 56,
  INPUT_HEIGHT: 72,
} as const;

// API 端点路径
export const API_ENDPOINTS = {
  SESSIONS: '/sessions',
  SESSION: (id: string) => `/sessions/${id}`,
  CHAT: (sessionId: string) => `/chat/${sessionId}`,
  CONFIG: (key: string) => `/config/${key}`,
  CONFIG_MODELS: '/config/models',
} as const;

// 默认值
export const DEFAULTS = {
  TEMPERATURE: 0.7,
  MAX_TOKENS: 4096,
  RAG_TOP_K: 10,
} as const;

// 脑区颜色映射
export const BRAIN_REGION_COLORS: Record<string, string> = {
  instinct: COLORS.instinctRed,
  emotional: COLORS.emotionOrange,
  rational: COLORS.rationalBlue,
} as const;

// 阶段中文映射（与后端架构一致）
export const STAGE_LABELS: Record<string, string> = {
  opening: '开场',
  exploring: '探索',
  deepening: '深化',
  integrating: '整合',
  landing: '落地',
  closing: '结束',
} as const;

// 阶段顺序
export const STAGE_ORDER = [
  'opening',
  'exploring',
  'deepening',
  'integrating',
  'landing',
  'closing',
] as const;

// 脑区中文映射
export const BRAIN_REGION_LABELS: Record<string, string> = {
  instinct: '本能脑',
  emotional: '情感脑',
  rational: '理智脑',
} as const;

// SSE 事件类型
export const SSE_EVENT_TYPES = {
  CHUNK: 'chunk',
  DONE: 'done',
  ERROR: 'error',
  SAFETY_ALERT: 'safety_alert',
} as const;
